const state = {
  // 配置1-合约地址
  dappAddress: 'n1rtR3JqyWvt2vKyELY57cdNZhAxgA2vBjD',
  user: null,
  nebPay: null,
  accounts: null,
  accountsError: null,
  activeMenu: 'help'
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js